<template>
    <div class="whole-screen" v-if="userId !== null">
        <div class="top-bar-container" :class="[{'mobile-scrolled' : isMobileScrolled}, topBarClass]">

            <!-- TOP BAR/HEADER (TODO: Move out) -->
            <top-bar :isMobile="isMobile"></top-bar>
            <!-- TOP BAR/HEADER END -->

            <!-- NAVIGATION MOBILE -->
            <navigation :mobileMenu="true" :isMobile="isMobile" @mobileMenuOpen="mobileMenuOpened=true"></navigation>
            <!-- NAVIGATION MOBILE END -->

        </div>

        <div class="wide-inner">
            <div class="columns">
                <!-- NAVIGATION -->
                <navigation :isMobile="isMobile" :mobileMenuOpened="mobileMenuOpened" @mobileMenuClose="mobileMenuOpened=false"></navigation>
                <!-- NAVIGATION END -->

                <!-- ACTUAL CONTENT -->
                <div class="middle-column">
                    <router-view></router-view>
                </div>
                <!-- ACTUAL CONTENT END -->

                <!-- RIGHT INFO SIDEBAR -->
                <info-sidebar :isMobile="isMobile"></info-sidebar>
                <div class="third-column-placeholder" :class="{'collapsed': thirdPlaceholderCollapsed}">

                </div>
                <!-- RIGHT INFO SIDEBAR END -->
            </div>
        </div>

        <div class="footer-container">
            <footer-bar :isMobile="isMobile"></footer-bar>
        </div>
    </div>
    <div class="whole-screen" v-else style="text-transform: uppercase;">
        {{ $t('global.loading') }}
    </div>

</template>
<script>
//TODO: 1. Better mobile detection

import Navigation from '../components/layout/navigation.vue';
import InfoSidebar from '../components/layout/info-sidebar.vue';
import TopBar from '../components/layout/top-bar.vue';
import FooterBar from '../components/layout/footer-bar.vue';

import { mapState } from 'pinia'
import { useUser } from '../stores/user';

export default {
    data() {
        return {
            isMobile: false,
            isMobileScrolled: false,
            topBarClass: 'top-bar-regular',
            mobileMenuOpened: false,
            thirdPlaceholderCollapsed: true
        }
    },

    components: {
        Navigation,
        InfoSidebar,
        TopBar,
        FooterBar
    },

    created() {
        window.addEventListener("scroll",
            _.debounce(this.handleScroll, 50),
            {"passive": true}
        );
        this.onResize();
        window.addEventListener(
            "resize",
            _.debounce(this.onResize, 50)
        );
    },

    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },

    computed: {
        ...mapState(useUser, {userId: 'id'}),

        infoSidebarOpenStatus() {
            return this.$sidebar('isOpen');
        },
    },

    watch: {
        infoSidebarOpenStatus(value) {
            if (value) {
                this.showInfoSidebar();
            } else {
                this.hideInfoSidebar();
            }
        }
    },

    methods: {
        handleScroll() {
            if(window.scrollY > 60) {
                //User scrolled the screen
                if(this.isMobile) {
                    this.isMobileScrolled=true;
                    this.topBarClass = 'top-bar-mobile-scrolled';
                } else {
                    this.topBarClass = 'top-bar-scrolled';
                }
            } else {
                //user is back on top
                if(this.isMobile) {
                    this.isMobileScrolled=false;
                    this.topBarClass = 'top-bar-mobile';
                } else {
                    this.topBarClass = 'top-bar-regular';
                }
            }
        },

        onResize() {
            this.isMobile = window.innerWidth < 600; //TODO: Replace with "real" mobile detection. Possibly differentiate between mobile and tablet too.

            if(this.isMobile) {
                this.adaptToMobile();
            } else {
                this.adaptToFull();
            }
        },

        adaptToMobile() {
            this.thirdPlaceholderCollapsed = true;
            this.topBarClass = 'top-bar-mobile';
        },

        adaptToFull() {
            this.topBarClass = 'top-bar-regular';
            this.isMobileScrolled=false;
            if (this.infoSidebarOpenStatus) {
                this.thirdPlaceholderCollapsed = false;
            } else {
                this.thirdPlaceholderCollapsed = true;
            }
        },

        showInfoSidebar() {
            if (!this.isMobile) {
                this.thirdPlaceholderCollapsed = false;
            }
        },

        hideInfoSidebar() {
            if (!this.isMobile) {
                this.thirdPlaceholderCollapsed = true;
            }
        }

    }
}
</script>
